import { PlayerMetricHeuristic } from '../../../jscaip/AI/PlayerMetricHeuristic';
export class CheckersScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        return node.gameState.getScores().toTable();
    }
}
